import React from "react";
import { formatBRDate } from "../utils/date";
import { 
  CalendarDays, 
  Clock, 
  MapPin, 
  Users, 
  Coins, 
  Sparkles,
  Plus
} from "lucide-react";

export const LodgeAgendaView = ({
  sessions,
  onOpenNewSessionModal,
  canCreateSession = true, // Venerável ou Secretário
}) => {
  const formatCurrency = (val) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(val || 0);
  };

  return (
    <div className="space-y-6" data-testid="lodge-agenda-view">
      
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>
          <h2 className="text-2xl font-serif font-bold text-white">Agenda Litúrgica da Loja</h2>
          <p className="text-xs text-slate-400">
            Calendário de Sessões Ordinárias, Magnas, Instruções e Eventos Fraternais
          </p>
        </div>

        {canCreateSession && (
          <button
            onClick={onOpenNewSessionModal}
            data-testid="btn-new-session-agenda"
            className="flex items-center space-x-1.5 bg-[#D4AF37] hover:bg-[#C5A028] text-slate-950 font-bold px-4 py-2.5 rounded-xl text-xs uppercase tracking-wider transition-all shadow-[0_0_15px_rgba(212,175,55,0.25)]"
          >
            <Plus className="w-4 h-4" />
            <span>Nova Sessão na Agenda</span>
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {sessions.map((sess) => (
          <div key={sess.id} className="luxury-card p-5 space-y-3 hover:border-[#D4AF37]/60 transition-all">
            <div className="flex items-start justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 rounded-xl bg-[#080D18] border border-slate-800 flex flex-col items-center justify-center font-mono">
                  <span className="text-[10px] text-slate-400 uppercase">
                    {(() => {
                      const m = String(sess.date || "").match(/^\d{4}-(\d{2})-\d{2}/);
                      const meses = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
                      return m ? meses[parseInt(m[1], 10) - 1] : "";
                    })()}
                  </span>
                  <span className="text-base font-bold text-[#D4AF37]">
                    {(() => {
                      const m = String(sess.date || "").match(/^\d{4}-\d{2}-(\d{2})/);
                      return m ? parseInt(m[1], 10) : "";
                    })()}
                  </span>
                </div>
                <div>
                  <span className="font-mono text-xs font-bold text-[#D4AF37] block">
                    Sessão nº {sess.session_number}
                  </span>
                  <h3 className="font-serif font-bold text-sm text-white">{sess.title}</h3>
                </div>
              </div>

              <span className="text-[10px] px-2 py-0.5 rounded-full bg-blue-500/10 text-blue-400 border border-blue-500/30">
                {sess.session_type}
              </span>
            </div>

            <p className="text-xs text-slate-300 line-clamp-2">
              {sess.agenda || "Trabalhos litúrgicos e ordem do dia da Oficina."}
            </p>

            <div className="pt-2 border-t border-slate-800/80 flex items-center justify-between text-[11px] text-slate-400">
              <span className="flex items-center space-x-1">
                <Clock className="w-3.5 h-3.5 text-[#D4AF37]" />
                <span>20h00 • Templo Principal</span>
              </span>
              <span className="font-bold text-emerald-400">
                {sess.present_member_ids?.length || 0} Irmãos Confirmados
              </span>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};
